'use client';

import React from 'react';
import { motion } from 'motion/react';
import LoginWithOAuth from './LoginWithOAuth';
import { cn } from '@/lib/utils';

interface YouNeedToLoginProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'modal';
  message?: string;
}

const YouNeedToLogin = (props: YouNeedToLoginProps) => {
  const { message = 'Sign in', className } = props;

  return (
    <motion.div
      className={cn('max-w-3xl px-4 text-center sm:w-full sm:px-0', className)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      {message && <p className="">{message}</p>}
      <div className="flex flex-col items-center justify-center gap-4 py-4 sm:py-6">
        <LoginWithOAuth provider="github" />
        {`or`}
        <LoginWithOAuth provider="google" />
      </div>
      <p className="pt-4">to enable better stats and email reminders.</p>
    </motion.div>
  );
};

export default YouNeedToLogin;
